import { render, staticRenderFns } from "./TagFilter.vue?vue&type=template&id=739f4506&"
import script from "./TagFilter.vue?vue&type=script&lang=js&"
export * from "./TagFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports